export default __webpack_public_path__ + "static/media/bh.5bb344c6.svg";